import { diffMilliseconds } from '@djs';
import { StoryAbstractStatus } from './StoryAbstract';

const canInteractStatus = new Set<StoryAbstractStatus>(['playing', 'paused', 'inited', 'suspend']);

export const canInteract = (status: StoryAbstractStatus) => canInteractStatus.has(status);

export const parseStoryTags = (url: string): Record<string, any> => {
  const result = url.match(/sun(\d+)-(\d+)/) || [];

  return {
    sun: result[0],
    'sun.region': result[1],
    'sun.server': result[2],
  };
};

const getEmptyBase46Image = () => {
  const canvas = document.createElement('canvas');
  canvas.height = 1;
  canvas.width = 1;

  return canvas.toDataURL();
};

export const EMPTY_BASE64_IMAGE = getEmptyBase46Image();

export const getStoryCurrentTime = (startTime: Date, totalPausedTime: number) => {
  return diffMilliseconds(new Date(), startTime) - totalPausedTime;
};
